import styled from "styled-components";

export const BreadcrumbsContainer = styled.div`
  &.nav-title {
    display: flex;
    align-items: center;
    font-family: "Public Sans", sans-serif;
    font-weight: 600;
    font-size: 14px;
    color: #717680;
  }

  .title-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .crumb {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
`;

export const BackButton = styled.button`
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid #d5d7da;
  box-shadow: 0 0 0 1px rgba(10, 13, 18, 0.18) inset,
    0 -2px 0 0 rgba(10, 13, 18, 0.05) inset, 0 1px 2px 0 rgba(10, 13, 18, 0.05);
`;

export const CrumbSeparator = styled.span`
  display: inline-flex;
  align-items: center;
  color: inherit;
`;

export const CrumbTitle = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  cursor: pointer;
  color: ${({ isLast }) => (isLast ? "#717680" : "rgba(10, 13, 18, 0.50)")};
`;

export const CrumbText = styled.span`
  color: ${({ isLast }) => (isLast ? "#717680" : "rgba(10, 13, 18, 0.50)")};
`;
